
export enum DynamicPriceLocationTypeCd {
	BILL_TO = 'BillTo',
	CORPORATE = 'Corporate',
	PICKUP_AND_DELIVERY = 'PickupAndDelivery'}

